const EXPAND_CONTAINER = "expand-container";
export {
  EXPAND_CONTAINER
};
//# sourceMappingURL=data-hooks.js.map
